import { Component } from '@angular/core';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

@CoreBuildingBlock('checkbox')
@Component({
  selector: 'cu-checkbox',
  templateUrl: './checkbox.component.html',
  standalone: false
})
export class CheckboxComponent extends CoreBuildingBlockControlBaseComponent {
  /**
   * Value proxy for map
   */
  public get value(): boolean {
    // Added below logic to fix the prefill issue in checkbox field which have map config.
    if (this.field.config && this.field.config.map && Object.keys(this.field.config.map).length > 0) {
      return this.field.data.value === this.field.config.map.true;
    }
    return this.field.data.value && this.field.data.value.toString().toLowerCase() === 'true' ? true : false;
  }

  /**
   * Value proxy for map
   */
  public set value(val: boolean) {
    this.field.data.value = val
      ? (this.field.config.map && this.field.config.map.true) || true
      : (this.field.config.map && this.field.config.map.false) || false;
  }
}
